import Card from "./card.js";
import Map from "./map.js"
import mediumZoom from 'medium-zoom'

fetch("./places.json")
.then(res => res.json())
.then(places => {
  console.log(places)
  const sortedPlaces = places.sort(sortByProperty("name"));
  function sortByProperty(property){  
    return function(a,b){  
       if(a[property] > b[property])  
          return 1;  
       else if(a[property] < b[property])  
          return -1;  
       return 0;  
    }  
 }
 sortedPlaces.forEach(p => {
    if (p && p.type && ["inn", "bed & breakfast", "hotel"].includes(p.type)) {
      const card = new Card({
        name: p.name,
        subtitle: `${p.name} is located in ${p.city} and is a ${p.drive_time} minute drive from the venue.`,
        about: p.about,
        type: p.type,
        url: p.url,
      });
      document.querySelector("#cards").appendChild(card);
    }
  })
})

/*    "name": "Clary Lake BnB",
    "address": "Jefferson",
    "coords": "",
    "url": "http://www.clarylakebedandbreakfast.com/",
    "about": "",
    "phone": "(207)-549-5961",
    "drive_time": "22",
    "type": "stay"*/

Map("./places.json");

function createGallery(id, imageName, start, end) {
  const gallery = document.createElement("div")
  gallery.classList = "gallery";
  for (let i = start; i <= end; i++) {
    // if (end - start === 6) {
    //   gallery.innerHTML += /*html*/`
    //   <figure class="gallery__item_gallery__item--${i} ${(i === 2 || i === 6) ? 'wide' : (i === 5 || i === 11) ? 'tall' : (i === 4) ? 'tall-sm' : (i === 3) ? 'wide-sm' : ''}">
    //       <img src="img/${imageName}-${i}.webp"  alt="Gallery Image" class="gallery__img">
    //   </figure>        
    //   `
    // }
    // else{
      gallery.innerHTML += /*html*/`
      <figure class="gallery__item_gallery__item--${i}">
        <img src="img/${imageName}-${i}.webp" alt="Gallery Image" class="gallery__img">
      </figure>        
      `
    // }
  }
  document.querySelector(id).appendChild(gallery)
}

// createGallery("#venue-gallery", "venue", 3, 5);
createGallery("#maine-gallery", "maine", -1, 4);
createGallery("#story-gallery", "jh", 1, 4);

mediumZoom(document.querySelectorAll(".gallery__img"))